import React from "react";
import { CTA } from "../mock";
import { Eyebrow } from "./Hero";
import ClassCard from "./ClassCard";

export default function HowItWorks() {
  return (
    <section id="live-classes" data-testid="live-classes-section" className="relative scroll-mt-24 py-14 md:scroll-mt-28 md:py-16 sep-top">
      <div className="mx-auto max-w-6xl px-6 md:px-10">
        <div className="mb-5 text-center">
          <Eyebrow text={CTA.liveEyebrow} testId="live-classes-eyebrow" />
          <h2 className="eyebrow-title-gap font-display text-3xl leading-[1.05] md:text-[2.1rem]" data-testid="live-classes-heading" style={{ color: "#201850" }}>{CTA.liveHeading}</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm md:text-base" data-testid="live-classes-description" style={{ color: "rgba(32,24,80,0.7)" }}>
            Attend a live EazyBot class to learn more details and get<span className="hidden md:inline"><br /></span>{" "}your questions answered.
          </p>
        </div>
        <ClassCard />
      </div>
    </section>
  );
}